import * as React from 'react';
import {useState} from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import ReactPlayer from 'react-player';
import {Table, Container} from 'react-bootstrap';
import Navbar from './Navbar';
import Footer from './Footer';
import '../css/modal.css';

function QRMenu() {

    const vidList = [
        {
            'name' : 'Chicken Biryani',
            'link' : 'https://www.youtube.com/watch?v=HS24PywYlxg',
            'price' : '220Rs'
        },
        {
            'name' : 'Fish curry meals',
            'link' : 'https://www.youtube.com/watch?v=V5w1OGknhlc',
            'price' : '120Rs'

        },
        {
            'name' : 'Egg biryani',
            'link' : 'https://www.youtube.com/watch?v=HS24PywYlxg',
            'price' : '120Rs'

        },
        {
            'name' : 'Mandi chicken',
            'link' : 'https://www.youtube.com/watch?v=V5w1OGknhlc',
            'price' : '580Rs'

        },
        {
            'name' : 'Kabsa Mutton',
            'link' : 'https://www.youtube.com/watch?v=HS24PywYlxg',
            'price' : '900Rs'

        }
    ]
    const [modalShow, setModalShow] = React.useState(false);
    const [menuItemChosen, setMenuItemChosen] = React.useState('');
    const [menuItemURL, setMenuItemURL] = React.useState('');

    function selectedMenu(props){
        console.log(props)
        setModalShow(true);
        setMenuItemChosen(props);
        setMenuItemURL(vidList.find(itemName => itemName.name==props).link);
    }


    function MyVerticallyCenteredModal(props) {
        return (
            <Container>
                <Modal
                    {...props}
                    size="xl"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                    dialogClassName="my-modal"
                >
                    <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        {menuItemChosen}
                    </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                    <ReactPlayer
                    className='react-player'
                    url={menuItemURL}
                    width='100%'
                    height='400px'
                    />
                    </Modal.Body>
                    <Modal.Footer>
                    <Button onClick={props.onHide}>Close</Button>
                    </Modal.Footer>
                </Modal>
        </Container>
        );
    }

    return (
        <>
            <Container width="100%">
                <Navbar/>
                <div class="position-relative">
                    <div class="position-relative start-50 translate-middle-x">
                        <h2  class="py-3 text-dark">The RESORT</h2>    
                    </div>
                </div>
    
                <Table striped bordered hover >
                    <thead>
                    <tr>
                        <th>Item</th>
                        <th>Price</th>
                    </tr>
                    </thead>
                {
                    vidList.map((item,index) =>
                    <>

                    <tbody>
                    <tr>
                        <td><Button variant="primary" onClick={() => selectedMenu(item.name)}>
                        {item.name}
                        </Button></td>
                        <td>{item.price}</td>
                    </tr>
                    </tbody>
                    </>
                    )
                }
                </Table>
                <MyVerticallyCenteredModal
                show={modalShow}
                onHide={() => setModalShow(false)}
            />
            <Footer/>
        </Container>
        </>
  );
}

export default QRMenu;
